// extracted by mini-css-extract-plugin
export default {"item-list":"MainsDesktop_item-list__IF8SU","item":"MainsDesktop_item__PdisZ","main-section":"MainsDesktop_main-section__A9RZa","mains-subtitle":"MainsDesktop_mains-subtitle__Dxo5P"};